<div class="limite-diario">
  <div class="lista-limite">
      <h2>Limite Gasto Diário</h2> 
      <mat-slide-toggle [(ngModel)]="hasDailyLimit" (change)="disableDailyLimit($event)"></mat-slide-toggle>
  </div>
 
  <div class="values" *ngIf="hasDailyLimit">
    <app-input-currency [inputModel]="dailyLimitInputModel"  [(value)]="dailyLimitToShow" class="value-payment"></app-input-currency>    
    
  </div>
  <button *ngIf="hasDailyLimit" (click)="enableDailyLimit()" class="confirma confirma-edit">
      Confirmar
  </button>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/daily-limit/daily-limit.component.html